// src/features/api/apiSlice.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {logoutAction} from "../slices/authSlice"
import MyToast from "../../components/Toast"
import { SESSION_EXPIRED_MESSAGE } from "../../utils/session"

const baseUrl = process.env.REACT_APP_BASE_URL
const baseQuery = fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: (headers, { getState }) => {
        const token = getState().auth.authData?.token; // Assuming you have auth in your state

        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
    },
});
const baseQueryWithAuth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);
    // 401 and 403 both mean the admin token is invalid or expired.
    if (result.error && [401, 403].includes(result.error.status)) {
        // A 401 on a failed login attempt is not an expired session, so only explain it when a token existed.
        const hadSession = Boolean(api.getState().auth?.authData?.token);
        api.dispatch(logoutAction());
        if (hadSession) MyToast('e', SESSION_EXPIRED_MESSAGE);
    }
    return result;
};

export const apiSlice = createApi({
    reducerPath: 'api',
    baseQuery: baseQueryWithAuth, // Replace with your API base URL
    // One tag per screen `key` passed to useCustomDynamicQuery/useMutation (RUNTIME-007)
    tagTypes: ['userList', 'userDetail', 'adminProfile', 'onboardingScreenList', 'contactUsList', 'feedbackList', 'dashboard_data', 'common_content', 'root'],
    endpoints: (builder) => ({
        dynamicQuery: builder.query({
            query: ({ endpoint, params, key, headers }) => {
                const queryParams = new URLSearchParams(params).toString();
                return {
                    url: `${endpoint}?${queryParams}`,
                    method: 'GET',
                    headers: headers || {}, // Use provided headers or an empty object
                };
            },
            providesTags: (result, error, { key }) => [key],
        }),
        dynamicMutation: builder.mutation({
            query: ({ endpoint, method = 'POST', body, headers }) => {
                // console.log("key@@@", key);
                return {
                    url: endpoint,
                    method: method,
                    body,
                    headers: headers || {},
                }
            },
            // key may be one tag or a list, e.g. ['userList', 'userDetail']
            invalidatesTags: (result, error, { key }) => {
                return key ? [].concat(key) : []
            },
        }),
    }),
});

export const { useDynamicQueryQuery, useDynamicMutationMutation } = apiSlice;
